import Button from "../gui/Button/Button"
import ExclaimIcon from "../gui/Icons/ExclaimIcon"
import { usePath } from "../libs/path/PathProvider"
import { TErrorMsg } from "../libs/Utils"
import { useFoods } from "../utils/FoodProvider"

export default function(props:{error:TErrorMsg}){
    const {loadFoods} = useFoods()
    const {setPath} = usePath()

    const onRetry = () => loadFoods().then(() => setPath("/home")).catch((e:any) => {})
    return <div id="error">
        <ExclaimIcon/>
        <h1>{props.error.title || "Error"}</h1>
        <p>{props.error.message || ""}</p>
        <Button variant="contained" onClick={onRetry}>Retry</Button>
    </div>
}